<template>
    <login-layout
        eyebrow="Seguridad de la cuenta"
        titulo="Cambie su contraseña"
        :subtitulo="obligatorio
            ? 'Su contraseña es temporal. Defina una propia para continuar.'
            : 'Defina una contraseña nueva para su cuenta.'">

        <v-form ref="form" v-model="valido" @submit.prevent>
            <v-text-field
                class="campo" outlined prepend-inner-icon="lock_clock"
                :label="obligatorio ? 'Contraseña temporal' : 'Contraseña actual'"
                autocomplete="current-password"
                :type="oculto ? 'password' : 'text'"
                :append-icon="oculto ? 'visibility_off' : 'visibility'"
                v-model="modelo.password_actual"
                :rules="[(v) => !!v || 'Campo requerido']"
                @click:append="oculto = !oculto"
            />
            <v-text-field
                class="campo" outlined prepend-inner-icon="key"
                label="Contraseña nueva" autocomplete="new-password"
                :type="oculto ? 'password' : 'text'"
                v-model="modelo.password"
                :rules="reglasPassword"
            />
            <v-text-field
                class="campo" outlined prepend-inner-icon="key"
                label="Confirmar contraseña nueva" autocomplete="new-password"
                :type="oculto ? 'password' : 'text'"
                v-model="modelo.password_confirmation"
                :rules="[(v) => v === modelo.password || 'Las contraseñas deben coincidir']"
                @keyup.enter="guardar"
            />

            <ul class="requisitos">
                <li v-for="requisito in requisitos" :key="requisito.texto" :class="{cumple: requisito.cumple}">
                    <v-icon x-small>{{ requisito.cumple ? 'check_circle' : 'radio_button_unchecked' }}</v-icon>
                    {{ requisito.texto }}
                </li>
            </ul>

            <v-btn class="boton-principal mt-3" depressed :loading="cargando" @click="guardar">
                Guardar contraseña
                <v-icon right>check</v-icon>
            </v-btn>
        </v-form>

        <template #pie>
            <a href="#" @click.prevent="salir">
                <v-icon>{{ obligatorio ? 'logout' : 'arrow_back' }}</v-icon>
                {{ obligatorio ? 'Cerrar sesión' : 'Volver' }}
            </a>
        </template>
    </login-layout>
</template>

<script>
import Ls from "@/services/ls";
import Auth from "@/services/auth";
import LoginLayout from "@/components/Login/LoginLayout.vue";
import {reglasPassword, MINIMO_PASSWORD} from "@/services/password";

export default {
    name: "CambiarPassword",
    components: {LoginLayout},
    data() {
        return {
            valido: true,
            cargando: false,
            oculto: true,
            obligatorio: false,
            reglasPassword,
            modelo: {password_actual: "", password: "", password_confirmation: ""},
        }
    },
    computed: {
        requisitos() {
            const p = this.modelo.password || "";
            return [
                {texto: `Al menos ${MINIMO_PASSWORD} caracteres`, cumple: p.length >= MINIMO_PASSWORD},
                {texto: "Mayúsculas y minúsculas", cumple: /[A-Z]/.test(p) && /[a-z]/.test(p)},
                {texto: "Un número", cumple: /[0-9]/.test(p)},
                {texto: "Un símbolo (# ? ! @ $ % & * -)", cumple: /[^A-Za-z0-9]/.test(p)},
            ];
        },
    },
    methods: {
        guardar() {
            if (!this.$refs.form.validate()) return;

            this.cargando = true;

            window.axios.post('/usuarios/cambiar_password', this.modelo).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.$router.push({name: 'Inicio'});
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    const cuerpo = error.response && error.response.data;
                    const detalle = cuerpo && cuerpo.data && typeof cuerpo.data === "object"
                        ? Object.values(cuerpo.data).flat().join(" ")
                        : null;
                    this.$toast.error(detalle || "No se pudo cambiar la contraseña.");
                })
                .finally(() => {
                    this.cargando = false;
                });
        },
        salir() {
            if (!this.obligatorio) {
                this.$router.go(-1);
                return;
            }

            Auth.logout().then(() => this.$router.push({name: 'LoginAdmin'}));
        },
    },
    created() {
        if (!Ls.get("token")) {
            this.$router.push({name: 'LoginAdmin'});
            return;
        }

        window.axios.get('/usuarios/info').then(response => {
            this.obligatorio = !!(response.data.data && response.data.data.debe_cambiar_password);
        }).catch(() => {});
    },
}
</script>

<style scoped>
.requisitos {
    list-style: none;
    padding: 0;
    margin: 0 0 4px;
    font-size: 0.8rem;
    color: #6b7390;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2px 12px;
}

.requisitos li.cumple,
.requisitos li.cumple .v-icon {
    color: #2e7d32;
}
</style>
